import Swiper from 'swiper';
import {Navigation, Pagination, FreeMode, Scrollbar} from "swiper/modules";
import {ResponsiveHelper} from "./responsive-helper";

let isBusy = false;
const loadingClass = 'cdv-loading';
const activeClass = 'cdv-btn-active';

const enviesSwiperMap = new WeakMap();

/**
 * Bandeau ALM « envies » : liste de radios en Swiper horizontal (slidesPerView auto, freeMode).
 */
function teardownEnviesSwipersIn(scope) {
	if (!scope || !scope.querySelectorAll) {
		return;
	}
	scope.querySelectorAll('.cdv-envies-filters-bar .alm-filter--inner').forEach((inner) => {
		if (!inner.classList.contains('cdv-envies-filters-swiper') && !inner.classList.contains('swiper-initialized')) {
			return;
		}
		const sw = enviesSwiperMap.get(inner);
		if (sw && typeof sw.destroy === 'function') {
			try {
				sw.destroy(true, true);
			} catch {
				/* ignore */
			}
		}
		enviesSwiperMap.delete(inner);
		inner.classList.remove('swiper', 'swiper-initialized', 'cdv-envies-filters-swiper');
		const ul = inner.querySelector(':scope > ul');
		if (ul) {
			ul.removeAttribute('style');
			ul.classList.remove('swiper-wrapper');
			ul.querySelectorAll(':scope > li').forEach((li) => {
				li.classList.remove('swiper-slide');
				li.removeAttribute('style');
			});
		}
	});
}

function buildEnviesSwipersIn(scope) {
	if (!scope || !scope.querySelectorAll) {
		return;
	}
	scope.querySelectorAll('.cdv-envies-filters-bar .alm-filter--inner').forEach((inner) => {
		const ul = inner.querySelector(':scope > ul');
		if (!ul || ul.querySelectorAll(':scope > li').length === 0) {
			return;
		}
		if (inner.classList.contains('cdv-envies-filters-swiper')) {
			return;
		}

		inner.classList.add('swiper', 'cdv-envies-filters-swiper');
		ul.classList.add('swiper-wrapper');
		ul.querySelectorAll(':scope > li').forEach((li) => li.classList.add('swiper-slide'));

		const bar = inner.closest('.cdv-envies-filters-bar');
		const controls = bar ? bar.querySelector('.cdv-envies-filters-swiper-controls') : null;
		const nextEl = controls ? controls.querySelector('.swiper-button-next') : null;
		const prevEl = controls ? controls.querySelector('.swiper-button-prev') : null;
		const scrollbarEl = bar ? bar.querySelector('.cdv-envies-filters-scrollbar') : null;

		const swiperOptions = {
			modules: [FreeMode, Navigation, Scrollbar],
			slidesPerView: 'auto',
			spaceBetween: 5,
			freeMode: true,
			observer: true,
			observeParents: true,
			watchSlidesProgress: true,
		};
		if (nextEl && prevEl) {
			swiperOptions.navigation = { nextEl, prevEl };
		}
		// Barre de défilement draggable : masquée automatiquement par Swiper quand tout tient à l’écran.
		if (scrollbarEl) {
			swiperOptions.scrollbar = { el: scrollbarEl, draggable: true, hide: false };
		}

		const swiper = new Swiper(inner, swiperOptions);
		enviesSwiperMap.set(inner, swiper);
		inner.classList.add('swiper-initialized');
		scrollEnviesSwiperToActiveForInner(inner);
	});
}

/**
 * Fait défiler le swiper du bandeau envies (radios ALM) pour amener l’onglet actif
 * (`.active` / `aria-checked="true"`) à l’écran. Les radios ALM ne sont pas de vrais `<input>`.
 */
function scrollEnviesSwiperToActiveForInner(inner) {
	if (!inner) {
		return;
	}
	const run = () => {
		const swiper = enviesSwiperMap.get(inner);
		if (!swiper || typeof swiper.slideTo !== 'function') {
			return;
		}
		const active =
			inner.querySelector('.alm-filter--link.active') ||
			inner.querySelector('.alm-filter--link[aria-checked="true"]');
		if (!active) {
			return;
		}
		const li = active.closest('li');
		const ul = inner.querySelector(':scope > ul.swiper-wrapper');
		if (!li || !ul) {
			return;
		}
		const slides = Array.from(ul.querySelectorAll(':scope > li'));
		const index = slides.indexOf(li);
		if (index < 0) {
			return;
		}
		if (typeof swiper.update === 'function') {
			swiper.update();
		}
		// Un cran avant : sinon la pill active reste sous les flèches prev/next du bandeau.
		const targetIndex = Math.max(0, index - 1);
		swiper.slideTo(targetIndex, 0);
	};
	if (typeof requestAnimationFrame === 'function') {
		requestAnimationFrame(() => {
			requestAnimationFrame(run);
		});
	} else {
		setTimeout(run, 0);
	}
}

function scrollAllEnviesFiltersSwipersToActive() {
	document.querySelectorAll('.cdv-envies-filters-bar .alm-filter--inner.swiper-initialized').forEach((inner) => {
		scrollEnviesSwiperToActiveForInner(inner);
	});
}

/** Après sync URL (slug) côté cdv-common, ou reprise manuelle. */
window.cdvScrollEnviesSwiperToActive = scrollAllEnviesFiltersSwipersToActive;

function rebuildEnviesFiltersSwiperStrip() {
	document.querySelectorAll('.cdv-envies-filters-bar').forEach((bar) => {
		teardownEnviesSwipersIn(bar);
		buildEnviesSwipersIn(bar);
	});
}

/** Appelé depuis cdv-common.js après ALM (product-grid) pour resynchroniser le swiper. */
window.cdvRebuildEnviesFiltersSwiper = rebuildEnviesFiltersSwiperStrip;

function initEnviesFiltersSwiperStrip() {
	rebuildEnviesFiltersSwiperStrip();

	window.addEventListener('resize', () => {
		document.querySelectorAll('.cdv-envies-filters-bar .alm-filter--inner.swiper-initialized').forEach((inner) => {
			const sw = enviesSwiperMap.get(inner);
			if (sw && typeof sw.update === 'function') {
				sw.update();
			}
		});
	});
}

function initHideLinks(){
  const classname = document.getElementsByClassName("qcd");
  for (let i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', clickLeft, false);
    classname[i].addEventListener('contextmenu', clickRight, false);
  }
}

function clickLeft(event) {
  const attribute = this.getAttribute("data-qcd");
  const url = decodeURIComponent(window.atob(attribute));

  if (url.includes("#")) {
    const anchor = url.split("#")[1];
    const targetElement = document.getElementById(anchor);

    if (targetElement) {
      event.preventDefault(); // Empêche la navigation par défaut
      let offset = 40;
      const qcdOffset = this.getAttribute("data-qcd-offset");
      if(qcdOffset){
        offset = parseInt(qcdOffset);
      }
      if (window.innerWidth < 768) {
        const qcdOffsetMobile = this.getAttribute("data-qcd-offset-mobile");
        if(qcdOffsetMobile){
          offset = parseInt(qcdOffsetMobile);
        }
      }
      // Lecture du layout dans requestAnimationFrame
      requestAnimationFrame(() => {
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      });
    }
  } else {
    if (event.ctrlKey) {
      const newWindow = window.open(url, '_blank');
      newWindow.focus();
    } else {
      document.location.href = url;
    }
  }
}

function clickRight(event) {
  var attribute = this.getAttribute("data-qcd");
  if(event.ctrlKey) {
    var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
    newWindow.focus();
  } else {
    window.open(decodeURIComponent(window.atob(attribute)),'_blank');
  }
}

function onSuccess(holder, data) {
  const slider = holder.querySelector('.cdv-post-slider-filters');
  const sliderContainer = slider.querySelector('.swiper-wrapper');

  destroySlider(slider.swiper);

  const temp = document.createElement('div');
  temp.innerHTML = data;

  sliderContainer.innerHTML = '';
  [...temp.children].forEach(child => sliderContainer.appendChild(child));

  requestAnimationFrame(() => {
    initSwiperSlider('.cdv-filtration-section', '.cdv-post-slider-filters', {
      slidesPerView: 1,
      breakpoints: {
        600: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });
    initHideLinks();
  });
}

function destroySlider(swiper) {
  if (!swiper) return;

  swiper.destroy();
}

function filterItems(holder, filter, id) {
  if (isBusy) return;

  isBusy = true;
  holder.classList.add(loadingClass);
  const params = new URLSearchParams({ action: 'ajax_tabs', filter, id });
  const url = `${ajaxurl}?${params}`;
  fetch(url, {
    method: 'GET',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  })
    .then(response => response.text())
    .then(data => setTimeout(() => onSuccess(holder, data), 500))
    .catch(error => console.error('Erreur AJAX :', error))
    .finally(() => {
      isBusy = false;
      holder.classList.remove(loadingClass);
    });
}

function initSwiperSlider(holderSelector, sliderSelector, options) {
  document.querySelectorAll(holderSelector).forEach((holder) => {
    let slider = holder.querySelector(sliderSelector);
    const sliderButtonNext = holder.querySelector('.swiper-button-next');
    const sliderButtonPrev = holder.querySelector('.swiper-button-prev');
    if (!slider) return;

    new Swiper(slider, {
      navigation: { nextEl: sliderButtonNext, prevEl: sliderButtonPrev },
      modules: [Navigation],
      ...options,
    });
  });
}

function initHomeSwiperOperations() {
  document.querySelectorAll('.cdv-filtration-section').forEach((holder) => {
    const filterButtons = holder.querySelectorAll('.cdv-slider-filters button');
    const slider = holder.querySelector('.cdv-post-slider-filters');
    const sliderContainer = slider.querySelector('.swiper-wrapper');
    if (!filterButtons || !slider || !sliderContainer) return;

    let idFilter = '';
    let activeFilter = '';
    filterButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const filterValue = btn.getAttribute('data-filter');
        const idValue = btn.getAttribute('data-id');
        if (!filterValue || !idValue || btn.classList.contains(activeClass)) return;

        idFilter = idValue;
        activeFilter = filterValue;
        filterButtons.forEach(b => b.classList.remove(activeClass));
        btn.classList.add(activeClass);

        filterItems(holder, activeFilter, idFilter);
      });
    });
  });
}

function toggleSwiperControls(slider, sliderButtonNext, sliderButtonPrev) {
  if (!slider || !sliderButtonNext || !sliderButtonPrev) return;

  requestAnimationFrame(() => {
    const sw = slider.swiper;
    let isOverflowing;
    if (sw && typeof sw.isLocked === 'boolean') {
      isOverflowing = !sw.isLocked;
    } else {
      isOverflowing = slider.scrollWidth > slider.clientWidth;
    }

    sliderButtonNext.style.display = isOverflowing ? 'block' : 'none';
    sliderButtonPrev.style.display = isOverflowing ? 'block' : 'none';
  });
}

// Fake Load More init
function initFakeLoadMore() {
  const itemsPerLoad = 12;
  const hiddenClass = 'hidden-item';
  document.querySelectorAll('.cdv-section-cards-grid').forEach((holder) => {
    const items = holder.querySelectorAll('.cdv-grid-list > li');
    const btnMore = holder.querySelector('.cdv-btn-link');
    const slider = document.querySelector('.cdv-grid-slider');
    let sliderAPI = null;
    let visibleItems = itemsPerLoad;  // Initial items to show

    // Hide the button if items are less than the first load
    if (items.length <= itemsPerLoad && btnMore) {
      btnMore.classList.add(hiddenClass);
    }

    ResponsiveHelper.addRange({
      '..767': {
        on: () => {
          if (btnMore) {
            btnMore.removeEventListener('click', loadMoreItems);
            btnMore.classList.add(hiddenClass);
          }
          showAllItems();
          initSlider();
        }
      },
      '768..': {
        on: () => {
          if (btnMore) {
            btnMore.addEventListener('click', loadMoreItems);
            btnMore.classList.remove(hiddenClass);
          }
          showLimitedItems(visibleItems);
          destroySlider();
        }
      }
    });

    // Show the initial items and load more when the button is clicked
    function loadMoreItems(e) {
      e.preventDefault();
      visibleItems += itemsPerLoad;
      showLimitedItems(visibleItems);

      // Hide the "Voir plus" button if all items are visible
      if (visibleItems >= items.length && btnMore) {
        btnMore.classList.add(hiddenClass);
      }
    }

    // Show only a limited number of items
    function showLimitedItems(count) {
      items.forEach((item, i) => {
        if (i < count) {
          item.classList.remove(hiddenClass);
        } else {
          item.classList.add(hiddenClass);
        }
      });
    }

    function showAllItems() {
      items.forEach(item => item.classList.remove(hiddenClass));
    }

    function initSlider() {
      if (!sliderAPI) {
        sliderAPI = new Swiper(slider, {
          speed: 500,
          loop: false,
          spaceBetween: 8,
          modules: [Navigation],
          slidesPerView: 'auto',
          passiveListeners: false,
          touchStartPreventDefault: false,
          navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
        });
      }
    }

    function destroySlider() {
      if (sliderAPI) {
        sliderAPI.destroy(true, true);
        sliderAPI = null;
      }
    }
  });
}

export function initSwiper() {
  initSwiperSlider('.cdv-grid-slider-fond', '.cdv-cards-slider', {
    breakpoints: { 640: { slidesPerView: 'auto', spaceBetween: 12 } },
    touchStartPreventDefault: false,
    passiveListeners: false,
    slidesPerView: 'auto',
    spaceBetween: 8,
  });
  initSwiperSlider('.cdv-grid-slider-envies', '.cdv-cards-slider', {
    breakpoint: { 640: { slidesPerView: 'auto', spaceBetween: 12 } },
    touchStartPreventDefault: false,
    passiveListeners: false,
    slidesPerView: 'auto',
    spaceBetween: 8,
  });
  initSwiperSlider('.cdv-section-destination', '.cdv-cards-slider', {
    touchStartPreventDefault: false,
    passiveListeners: false,
    slidesPerView: 'auto',
    spaceBetween: 8,
  });
  initSwiperSlider('.cdv-filtration-section', '.cdv-post-slider-filters', {
    breakpoints: { 600: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } },
    touchEventsTarget: 'wrapper',
    simulateTouch: true,
    slidesPerView: 1,
    spaceBetween: 8,
  });
  initSwiperSlider('.cdv-section-cards-grid-image', '.cdv-grid-slider', {
    breakpoints: { 640: { slidesPerView: 'auto', spaceBetween: 16 } },
    touchStartPreventDefault: false,
    passiveListeners: false,
    slidesPerView: 'auto',
    spaceBetween: 8,
  });
  initSwiperSlider('.cdv-grid-slider-carnet', '.cdv-cards-slider', {
    breakpoints: { 640: { slidesPerView: 'auto', spaceBetween: 16 } },
    touchStartPreventDefault: false,
    passiveListeners: false,
    slidesPerView: 'auto',
    spaceBetween: 8,
  });
  initSwiperSlider('.cdv-section-cards', '.cdv-post-slider', {
    breakpoints: { 600: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } },
    spaceBetween: 8,
  });
  initSwiperSlider('.cdv-section-tours', '.swiper', {
    breakpoints: { 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } },
    touchStartPreventDefault: false,
    passiveListeners: false,
    slidesPerView: 1,
  });
  initSwiperSlider('.cdv-blog-gallery', '.cdv-blog-gallery__slider', {
    slidesPerView: 1,
    spaceBetween: 12,
    touchStartPreventDefault: false,
    passiveListeners: false,
  });
  initSwiperSlider('.cdv-cards-slider-latest-news', '.cdv-cards-slider', {
    touchStartPreventDefault: false,
    passiveListeners: false,
    spaceBetween: 24,
    breakpoints: {
      0: { slidesPerView: '1', spaceBetween: 24 },
      420: { slidesPerView: 'auto', spaceBetween: 24 }
    },
  });
  initFakeLoadMore();

  document.querySelectorAll('.image-slider').forEach((slider) => {
    const paging = slider.querySelector('.swiper-pagination');
    const sliderButtonNext = slider.querySelector('.swiper-button-next');
    const sliderButtonPrev = slider.querySelector('.swiper-button-prev');
    new Swiper(slider, {
      loop: true,
      modules: [Navigation, Pagination],
      pagination: { el: paging, clickable: true },
      navigation: { nextEl: sliderButtonNext, prevEl: sliderButtonPrev },
    });
  });

  document.querySelectorAll('.fancybox-trigger').forEach((trigger) => {
    trigger.addEventListener('click', function(e) {
      const swiperDiv = document.querySelector('.swiper.image-slider');
      if (!swiperDiv) return;

      const slideIndex = parseInt(this.getAttribute('data-slide-index'), 10);
      swiperDiv.swiper.slideTo(slideIndex);
    });
  });

  document.querySelectorAll('.cdv-main-hero__slider').forEach((slider) => {
    const slides = slider.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    new Swiper(slider, {
      loop: true,
      speed: 1000,
      effect: 'fade',
      noSwiping: true,
      grabCursor: false,
      allowTouchMove: false,
      passiveListeners: false,
      touchStartPreventDefault: false,
      autoplay: { delay: 10000, disableOnInteraction: false },
    });
  });

  /**
   * Swiper attend wrapper + slides : le ul est le swiper-wrapper, chaque li un swiper-slide.
   * Sans cela, un seul « slide » englobe toute la liste.
   */
  function syncSelectedFiltersStripSlideClasses(swiperRoot) {
    const ul = swiperRoot ? swiperRoot.querySelector('#alm-selected-filters') : null;
    if (!ul) {
      return;
    }
    ul.classList.add('swiper-wrapper');
    ul.querySelectorAll(':scope > li').forEach((li) => {
      li.classList.add('swiper-slide');
    });
  }

  document.querySelectorAll('.cdv-cards-slider-filter').forEach((holder) => {
    let ajaxTimer;
    const swiperRoot = holder.querySelector('.cdv-cards-slider');
    const nextEl = holder.querySelector('.swiper-button-next');
    const prevEl = holder.querySelector('.swiper-button-prev');
    const scrollbarEl = holder.querySelector('.cdv-cards-slider-filter-scrollbar');
    const buttons = document.getElementsByClassName('btn-filter-search');

    if (!swiperRoot) {
      return;
    }

    syncSelectedFiltersStripSlideClasses(swiperRoot);

    const swiperOptions = {
      touchStartPreventDefault: false,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : {},
      passiveListeners: false,
      modules: [Navigation, FreeMode, Scrollbar],
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      // Largeurs de pills fractionnaires : sans arrondi ni marge de fin, la dernière
      // reste rognée car Swiper sous-estime la taille totale du wrapper.
      roundLengths: true,
      slidesOffsetAfter: 25,
    };
    // Mobile : la barre de défilement remplace les flèches (masquées en CSS).
    if (scrollbarEl) {
      swiperOptions.scrollbar = { el: scrollbarEl, draggable: true, hide: false };
    }

    const slider = new Swiper(swiperRoot, swiperOptions);

    toggleSwiperControls(swiperRoot, nextEl, prevEl);

    Array.from(buttons).forEach((button) => {
      button.addEventListener('click', () => {
        clearTimeout(ajaxTimer);
        ajaxTimer = setTimeout(() => {
          slider.update();
          toggleSwiperControls(swiperRoot, nextEl, prevEl);
        }, 1000);
      });
    });

    window.addEventListener('resize', () => {
      slider.update();
      toggleSwiperControls(swiperRoot, nextEl, prevEl);
    });
  });

  window.cdvRefreshSelectedFiltersStrip = function cdvRefreshSelectedFiltersStrip() {
    document.querySelectorAll('.cdv-cards-slider-filter').forEach((holder) => {
      const swiperRoot = holder.querySelector('.cdv-cards-slider');
      const nextEl = holder.querySelector('.swiper-button-next');
      const prevEl = holder.querySelector('.swiper-button-prev');
      if (!swiperRoot || !swiperRoot.swiper) {
        return;
      }
      syncSelectedFiltersStripSlideClasses(swiperRoot);
      swiperRoot.swiper.update();
      toggleSwiperControls(swiperRoot, nextEl, prevEl);
    });
  };

  document.querySelectorAll('.cdv-menu-slider-wrap').forEach((holder) => {
    const slider = holder.querySelector('.cdv-menu-slider');
    const nextEl = holder.querySelector('.swiper-button-next');
    const prevEl = holder.querySelector('.swiper-button-prev');
    let swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      modules: [Navigation, FreeMode],
      passiveListeners: false,
      touchStartPreventDefault: false,
      navigation: { nextEl, prevEl: prevEl },
      freeMode: true,
    });
    holder.classList.add('swiper-initialized');
    toggleSwiperControls(slider, nextEl, prevEl);
    window.addEventListener('resize', () => {
      swiper.update();
      toggleSwiperControls(slider, nextEl, prevEl);
    });
    // Assurer le style overflow pour empêcher tout débordement visuel
    holder.style.overflow = 'hidden';
  });

  document.querySelectorAll('.cdv-latest-news__slider').forEach((slider) => {
    const sliderButtonNext = slider.querySelector('.swiper-button-next');
    const sliderButtonPrev = slider.querySelector('.swiper-button-prev');

    const swiper = new Swiper(slider, {
      modules: [Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: sliderButtonNext,
        prevEl: sliderButtonPrev,
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 30 },
        1024: { slidesPerView: 3, spaceBetween: 40 },
      },
      allowTouchMove: true,
      speed: 800,
      autoplay: { delay: 5000, disableOnInteraction: false },
    });

    setEqualSlideHeights(swiper);
  });


  // Init the home swiper operations
  initHomeSwiperOperations();

  // Bandeau envies (ALM radios) : défilement horizontal type pills
  initEnviesFiltersSwiperStrip();

  // Appel lors du redimensionnement de la fenêtre
  window.addEventListener('resize', toggleSwiperControls);
}

function setEqualSlideHeights(swiper) {
  const slides = swiper.slides;
  let maxHeight = 0;

  slides.forEach(slide => slide.style.height = 'auto');

  slides.forEach(slide => {
    if (slide.offsetHeight > maxHeight) maxHeight = slide.offsetHeight;
  });

  slides.forEach(slide => slide.style.height = maxHeight + 'px');
}
